/**
 * A helper to format camelCased string to SNAKE_CASE
 */
export const camelToSnakeCase = (str: string) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toUpperCase()}`).toUpperCase();
